export default __webpack_public_path__ + "static/media/error.1bb9a542.png";